import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { parseHtml } from '../../../utils/common'
// import "./development-process.scss";

function DevelopmentProcess(props) {
  const [desc, setDesc] = useState('')
  const [active, setActive] = useState(0)
  let block = props.block

  function handleMouseHover(index, hover) {
    setDesc(hover)
    setActive(index)
  }

  useEffect(() => {
    let first = block?.process_steps[0]
    setDesc(first.hover)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <section className="startups-process-section m-none">
        <div className="startups-process-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="heading">
                  <h2>{block.short_title}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="process-list">
                  <ul className="">
                    {block?.process_steps.map((ele, index) => {
                      return (
                        <li
                          onMouseOver={() => handleMouseHover(index, ele.hover)}
                          className={`col-lg-3 ${
                            active === index ? 'active' : ''
                          }`}
                          key={index}
                        >
                          <span>{ele?.label}</span>
                        </li>
                      )
                    })}
                  </ul>
                </div>
                {desc && (
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div className="process-text">
                        {desc ? parseHtml(desc, true) : ''}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="startups-process-section mobile-process-inner">
        <div className="startups-process-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="heading">
                  <h2>{block.short_title}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="mobile-process-list">
                  <ul className="">
                    {block?.process_steps.map((ele, index) => {
                      return (
                        <li
                          onMouseOver={() => handleMouseHover(index, ele.hover)}
                          className={`col-lg-3 ${
                            active === index ? 'active' : ''
                          }`}
                          key={index}
                        >
                          <div className="process-list-title">{ele?.label}</div>
                          <div className="process-text">
                            {desc ? parseHtml(desc) : ''}
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default DevelopmentProcess
